{
  "title": "Ano ang nangyayari sa {town}",
  "lead": "Mga iskedyul, programa at anunsiyo ng bawat opisina, nasa iisang lugar.",
  "emergencyModeOn": "Naka-on ang emergency mode. Tingnan ang mga abiso at ang pinakamalapit na evacuation site.",
  "nearestSite": "Pinakamalapit na site",
  "quickActions": "Mabilisang link",
  "qaMap": "Mapa ng evacuation",
  "qaHotlines": "Mga hotline",
  "qaCrop": "Pinsala sa pananim",
  "feedTitle": "Mga post",
  "tabAll": "Lahat",
  "tabForYou": "Para sa iyo",
  "openCalendar": "Kalendaryo",
  "searchLabel": "Maghanap ng post",
  "searchPlaceholder": "Maghanap ng post o opisina",
  "clearSearch": "Burahin ang hinahanap",
  "filters": "Mga filter",
  "filtersCount": "Mga filter ({count})",
  "activeFilters": "Mga nakalapat na filter",
  "removeFilter": "Alisin ang filter: {name}",
  "filterOffice": "Opisina",
  "filterBarangay": "Barangay",
  "filterCategory": "Kategorya",
  "allOffices": "Lahat ng opisina",
  "allCategories": "Lahat ng kategorya",
  "applyFilters": "Ipakita ang resulta",
  "clearFilters": "Alisin ang mga filter",
  "openForRegistration": "Bukas ang rehistro",
  "onlyFollowed": "Sinusundan lang",
  "yourBarangay": "Iyong barangay",
  "yourBarangayHint": "Unang lalabas ang mga post para sa iyong barangay. Sa teleponong ito lang ito naka-save.",
  "emptyTitle": "Wala pang naka-post",
  "emptyBody": "Dito lalabas ang mga iskedyul, programa at anunsiyo kapag nag-post ang mga opisina.",
  "emptyFilteredTitle": "Walang tugmang post",
  "emptyFilteredBody": "Subukan ang ibang hanap o alisin ang ilang filter.",
  "forYouSignInTitle": "Sariling feed mo",
  "forYouSignInBody": "Mag-sign in at sundan ang mga opisina, barangay o paksa para makita rito ang kanilang mga post at maabisuhan ka.",
  "forYouEmptyTitle": "Wala ka pang sinusundan",
  "forYouEmptyBody": "Sundan ang mga opisina, barangay at paksang mahalaga sa iyo. Dito lalabas ang kanilang mga post.",
  "forYouQuietTitle": "Walang bago mula sa iyong sinusundan",
  "forYouQuietBody": "Walang kasalukuyang post ang mga opisina at paksang sinusundan mo. Tingnan ang tab na Lahat, o magdagdag ng susundan.",
  "chooseFollows": "Piliin ang susundan",
  "calendarLead": "Lahat ng iskedyul, programa at aktibidad ayon sa petsa.",
  "calendarView": "Ayos ng kalendaryo",
  "view_month": "Buwan",
  "view_week": "Linggo",
  "view_list": "Listahan",
  "prevMonth": "Nakaraang buwan",
  "nextMonth": "Susunod na buwan",
  "prevWeek": "Nakaraang linggo",
  "nextWeek": "Susunod na linggo",
  "backToToday": "Bumalik sa ngayon",
  "eventsCount": "{count} naka-iskedyul",
  "noEvents": "Walang naka-iskedyul.",
  "allDay": "Buong araw",
  "addToCalendarFor": "Idagdag ang {title} sa iyong kalendaryo",
  "listRange": "Sa susunod na {weeks} linggo.",
  "calendarEmpty": "Walang naka-iskedyul",
  "calendarEmptyBody": "Walang iskedyul o programa sa susunod na {weeks} linggo na tugma sa mga filter na ito.",
  "urgentTitle": "Mga agarang abiso"
}
